// Consent field preflight checks for the Batch PDF Upload modal.
// These reflect the accepted values in zippedpdfbulkupload.js so that a row
// can be corrected before it reaches the background worker.

export function parseOptInSelection(value) {
    const normalized = String(value ?? "").trim().toLowerCase().replace(/[\s_-]+/g, "");
    if (["yes", "y", "true", "1", "optin", "optedin"].includes(normalized)) {
        return { valid: true, canonical: "OptIn", error: "" };
    }
    if (["no", "n", "false", "0", "optout", "optedout"].includes(normalized)) {
        return { valid: true, canonical: "OptOut", error: "" };
    }
    return {
        valid: false,
        canonical: "",
        error: normalized ? `Unrecognized Opt-In Status "${String(value).trim()}".` : "Opt-In Status is required.",
    };
}

export function validateConsentEffectiveDate(value) {
    const raw = String(value ?? "").trim();
    if (!raw) return { valid: false, error: "Effective date is required." };

    let year;
    let month;
    let day;
    const us = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/);
    const iso = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s].*)?$/);
    if (us) {
        month = Number(us[1]);
        day = Number(us[2]);
        year = Number(us[3]);
        if (us[3].length === 2) year += 2000;
    } else if (iso) {
        year = Number(iso[1]);
        month = Number(iso[2]);
        day = Number(iso[3]);
    } else {
        return {
            valid: false,
            error: `Invalid effective date "${raw}". Enter M/D/YYYY, M/D/YY, or YYYY-MM-DD.`,
        };
    }

    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
        return { valid: false, error: `Invalid calendar date "${raw}".` };
    }
    return { valid: true, error: "" };
}

export function createPdfConsentFieldReviews(rows, getStatusCategory) {
    return rows.flatMap((row, rowIndex) => {
        if (getStatusCategory(row.Status) !== "process") return [];
        const originalOptInStatus = String(row["Opt-In Status"] ?? "").trim();
        const originalEffectiveDate = String(row["effective date"] ?? "").trim();
        const opt = parseOptInSelection(originalOptInStatus);
        const date = validateConsentEffectiveDate(originalEffectiveDate);
        return [{
            rowIndex,
            pdfPath: String(row.pdf_path ?? ""),
            originalOptInStatus,
            originalEffectiveDate,
            optInStatus: opt.valid ? opt.canonical : "",
            effectiveDate: originalEffectiveDate,
            optInEdited: false,
            dateEdited: false,
            confirmed: opt.valid && date.valid,
        }];
    });
}

export function isConfirmedConsentFieldReview(review) {
    return Boolean(review?.confirmed &&
        parseOptInSelection(review.optInStatus).valid &&
        validateConsentEffectiveDate(review.effectiveDate).valid);
}
